import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    state() {
        return {
            user: {
                token: null,
                email: null,
                phone: null,
                userId: null,
                isSuper: false,
                fullName: null,
                otpToken: null,
                isDomain: false,
                ntUsername: null,
                languageId: "tr",
                uiPermissions: [],
                refreshToken: null,
                operationQueueId: 0,
                expiredAccounts: [],
                autoLoggedOut: false,
                tokenExpiration: null,
                isSessionEnding: false,
                remainingSessionTime: 0,
                passwordResetUser: null,
                verificationSelectId: 0,
                expiredAccountsCount: 0,
                canProceedWithOtp: false,
                canChangePassword: false,
                isPasswordChanged: false,
                registeredWorkspaces: [],
                hasExpiredAccounts: false,
                activeWorkspaceSources: [],
                operationStatusIdle: false,
                operationStatusActive: false,
                refreshTokenExpiration: null,
                fireSessionNotification: false,
                isScheduledReplyEnabled: false
            }
        }
    },
    getters,
    actions,
    mutations
}